module.exports = __webpack_public_path__ + "static/assets/f96254ed8b384b77de8f2febce4611ac.svg";